/**
 * Compares two selected-property lists by value.
 *
 * Price queries run with `staleTime: 0`, so any change to the query key is a
 * real network round-trip per parking. Callers derive these lists from filter
 * state and can hand over a fresh-but-identical array, which a reference
 * comparison would treat as a change. Order is significant: callers build the
 * list from a fixed constant, so it is already stable.
 */
export const haveSameParkingProperties = (left, right) => {
    if (left === right)
        return true;
    if (!left || !right)
        return false;
    if (left.length !== right.length)
        return false;
    return left.every((property, index) => property === right[index]);
};
